'use strict';

export default {
    REGION: 'europe-west3',
    EMULATOR_URL: 'http://localhost:5010',
    LOCALES: {
        "en": "en-US",
        "de": "de-DE",
        "es": "es-ES",
    },
    CURRENCIES: {
        "USD": "$",
        "EUR": "€",
    },
    get ENV() {
        if (window.location.href.match(/stage/)) {
            return 'stage';
        }

        if (window.location.href.match(/localhost/)) {
            return 'dev';
        }

        return 'live';
    },
    get IS_LIVE() {
        return this.ENV === 'live';
    }
}
